export default __webpack_public_path__ + "static/media/red.984270f9.png";